export enum ArticleSideStoryTypes {
  Undefined = 'Undefined',
  Basic = 'Basic',
  Who = 'Who',
  What = 'What',
}
